import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import classnames from 'classnames';
import moment from 'moment';
import 'moment/locale/fr';
import {getFirstLastDateSession} from '../../../Courses/helpers';
import truncateText from '../../../../app/utils/truncateText';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import DownloadIcon from '@material-ui/icons/GetApp';
import UndoIcon from '@material-ui/icons/Undo';

const styles = theme => ({
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 16,
    },
});

class DashboardCoursesListItem extends Component {
    handleClickUnsubscribe = (e) => {
        e.preventDefault();

        const {course} = this.props;

        this.props.handleSlickUnsubscribe(course);
    };

    handleClickDownloadCertificate = (e) => {
        e.preventDefault();

        const {course} = this.props;

        if (course.currentUserCertificate !== '') {
            window.open(course.currentUserCertificate, '_blank');
        }
    };

    render() {
        const {course, classes} = this.props;

        moment.locale('fr');

        let url = '/formations/' + course.slug;

        let categoryName = '';

        if (Array.isArray(course.categories) && course.categories.length > 0) {
            // Copy the array (not a reference) => mandatory because we call shift() and that the render() function may be called more than once...
            let copyCategories = course.categories.slice(0);
            let category = copyCategories.shift();
            categoryName = category.name;
        }

        let speakerName = '';
        let speakerJob = '';

        if (Array.isArray(course.speakers) && course.speakers.length > 0) {
            let copySpeakers = course.speakers.slice(0);
            let speaker = copySpeakers.shift();
            speakerName = speaker.full_name;
            speakerJob = speaker.job;
        }

        const dateFormat = 'D MMM YY';
        let dates = '';
        let sessions = getFirstLastDateSession(course.sessions);

        if (sessions.length === 1) {
            dates = moment(sessions[0].date, 'YYYY-MM-DD').format(dateFormat);
        } else if (sessions.length === 2) {
            if (sessions[0].date && sessions[1].date) {
                let dateTime1 = sessions[0].date;
                let dateTime2 = sessions[1].date;

                dates = moment(dateTime1, 'YYYY-MM-DD').format(dateFormat);
                dates += '<br />';
                dates += moment(dateTime2, 'YYYY-MM-DD').format(dateFormat);
            }
        }

        const checkinDeadlineDate = moment(course.first_session_date, 'YYYY-MM-DD').subtract(course.checkin_deadline, 'days');
        const checkinDeadlineDatetime = checkinDeadlineDate.format('YYYY-MM-DD');
        const nowDatetime = moment().format('YYYY-MM-DD');
        let openCheckin = true;
        if (nowDatetime > checkinDeadlineDatetime) {
            openCheckin = false;
        }

        return (
            <div className="col-lg-3 col-md-6 col-sm-12" key={course.id}>
                <div className="item item-dashboard">
                    <div className="inner">
                        <div className="top">
                            {categoryName !== '' &&
                            <div className="category">
                                {categoryName}
                            </div>
                            }
                            <div className={classnames('dates', {
                                'multiple': (sessions.length > 1),
                            })}>
                                {ReactHtmlParser(dates)}
                            </div>
                        </div>
                        <div className="title">
                            {(course.status && course.status === 'publish') ? (
                                <Link to={url}>
                                    {ReactHtmlParser(truncateText(course.title, 70))}
                                </Link>
                            ) : (
                                <Fragment>
                                    {ReactHtmlParser(truncateText(course.title, 70))}
                                </Fragment>
                            )}
                        </div>
                        <div className="bottom">
                            {course.currentUserCertificate !== '' ? (
                                <Button variant="contained" size="small" color="primary" className="btn btn-register" onClick={this.handleClickDownloadCertificate}>
                                    <DownloadIcon className={classnames(classes.leftIcon, classes.iconSmall)} />
                                    Attestation
                                </Button>
                            ) : (
                                <Fragment>
                                    {openCheckin ? (
                                        <Button variant="contained" size="small" color="primary" className="btn btn-register" onClick={this.handleClickUnsubscribe}>
                                            <UndoIcon className={classnames(classes.leftIcon, classes.iconSmall)} />
                                            Me désinscrire
                                        </Button>
                                    ) : (
                                        <Tooltip title="Il n'est plus possible de se désinscrire de cette formation">
                                            <span>
                                                <Button variant="contained" size="small" color="primary" className="btn btn-register" disabled={true}>
                                                    <UndoIcon className={classnames(classes.leftIcon, classes.iconSmall)} />
                                                    Me désinscrire
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    )}
                                </Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DashboardCoursesListItem.propTypes = {
    classes: PropTypes.object.isRequired,
    course: PropTypes.object.isRequired,
    handleSlickUnsubscribe: PropTypes.func.isRequired,
};

export default withStyles(styles)(DashboardCoursesListItem);


// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Courses/DashboardCoursesListItem.js